import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/auth";

/**
 * Handles the OAuth return trip. The parent router mounts this component
 * synchronously (during render) whenever `window.location.hash` contains
 * `session_id=…`, so we can exchange it BEFORE any protected fetch runs.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/university", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        // Clean the URL fragment so it doesn't get re-processed
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/university", { replace: true, state: { user } });
      } catch (err) {
        setError(err.message || "Sign-in failed");
      }
    })();
  }, [navigate]);

  return (
    <div
      data-testid="auth-callback"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0a0a0f",
        color: "gold",
        fontFamily: "Georgia, serif",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      {error ? (
        <div>
          <h1 style={{ marginBottom: "1rem" }}>Sign-in failed</h1>
          <p style={{ color: "#e0e0e0" }}>{error}</p>
          <a
            href="/university"
            style={{ color: "gold", textDecoration: "underline" }}
          >
            Return to the University
          </a>
        </div>
      ) : (
        <div>
          <p style={{ letterSpacing: ".14em", textTransform: "uppercase" }}>
            Verifying your Federation credentials…
          </p>
        </div>
      )}
    </div>
  );
}
